import { useTranslation } from 'react-i18next'

import arrowIcon from '@assets/images/arrow_up-icon.svg'
import copyIcon from '@assets/images/copy-icon.svg'
import trashIcon from '@assets/images/trash-icon.svg'

import { InputLabel } from '@components/InputLabel'

import { SectionFieldModel } from '@types'

import { FormFieldCardProps } from '../FormFieldCard'

import {
  ArrowDownImg,
  ArrowUpImg,
  ButtonContainer,
  CardHeaderContainer,
  Container,
  Header,
} from './FormFieldSection.styled'

type ActionsProps = Pick<FormFieldCardProps, 'canDown' | 'canUp' | 'onDelete' | 'onDuplicate' | 'onUp' | 'onDown'>

type FieldSectionProps = {
  field: SectionFieldModel
  canUp: boolean
  canDown: boolean
  onChange: (updates: Partial<SectionFieldModel>) => void
} & ActionsProps

export const FormFieldSection: React.FC<FieldSectionProps> = ({
  field,
  canDown,
  canUp,
  onChange,
  onDelete,
  onDuplicate,
  onUp,
  onDown,
}: FieldSectionProps) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Header>
        <InputLabel
          required
          value={field.label}
          onChange={(value) => onChange({ label: value })}
          placeholder={t('modules_project-form-models_components_FormFieldSection_add_label')}
        />
      </Header>

      <CardHeaderContainer>
        {onDuplicate && (
          <ButtonContainer
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onDuplicate()
            }}
          >
            <img src={copyIcon} />
          </ButtonContainer>
        )}
        <ButtonContainer
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            onDelete()
          }}
        >
          <img src={trashIcon} />
        </ButtonContainer>
        {onDown && (
          <ButtonContainer
            disabled={!canDown}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onDown()
            }}
          >
            <ArrowDownImg src={arrowIcon} />
          </ButtonContainer>
        )}
        {onUp && (
          <ButtonContainer
            disabled={!canUp}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onUp()
            }}
          >
            <ArrowUpImg src={arrowIcon} />
          </ButtonContainer>
        )}
      </CardHeaderContainer>
    </Container>
  )
}
